<template>
  <!-- Step 1 -->
  <div class="w-full max-w-xl m-auto tex-center">
    <p class="font-bold mb-4 text-lg">Run details</p>

    <text-input :model-value="value.name" :error="value.errors ? value.errors.name : ''" class="pb-8 pr-6 w-full mt-10 font-bold" label="Name" placeholder="Run Name" @update:model-value="update('form.name', $event)" />

    <div class="flex items-center justify-between px-8 py-4">
      <a class="underline cursor-pointer" :href="`/projects/${project.id}`">Cancel</a>
      <a class="btn-blue px-8" :class="! value.name ? 'opacity-50 cursor-not-allowed' :''" @click="value.name ? update('step', value.step + 1): ''">Next</a>
    </div>
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    TextInput,
  },
  props: {
    project: Object,
    value: Object,
  },
  emits: ['input'],
  methods: {
    update(key, value) {
      this.$emit('input', { key, value })
    },
  },
}
</script>
